// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__fk4lT","sheet":"style_sheet__rWPMy","open":"style_open__0qu0X","modal":"style_modal__wuU1t","glassBorder":"style_glassBorder__Ifr1U"};